module.exports = __webpack_public_path__ + "img/ps.5c68a90d.png";